<template>
  <div>
    <el-dialog
      :title="value.isCreate ? '新增白名单项' : '修改白名单项'"
      center
      :visible="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="onClose"
      width="400px"
    >
      <el-form
        ref="form"
        :model="value.form"
        :rules="rules"
        label-width="100px"
        size="mini"
      >
        <el-form-item label="类型：">
          <el-radio-group v-model="value.byType">
            <el-radio :disabled="value.isCreate == false" label="uid"
              >UID</el-radio
            >
            <el-radio :disabled="value.isCreate == false" label="aid"
              >AID</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item :hidden="value.byType != 'uid'" label="UID">
          <el-input
            v-model="value.form.uid"
            :disabled="value.isCreate ? false : true"
          ></el-input>
        </el-form-item>
        <el-form-item :hidden="value.byType != 'aid'" label="AID">
          <el-input
            v-model="value.form.aid"
            :disabled="value.isCreate ? false : true"
          ></el-input>
        </el-form-item>
        <el-form-item label="过滤类型：">
          <el-radio v-model="value.form.type" :label="0" @input="changeRadio"
            >物品</el-radio
          >
          <el-radio v-model="value.form.type" :label="1" @input="changeRadio">
            检测项
          </el-radio>
        </el-form-item>
        <el-form-item v-if="value.form.type == 0" label="道具：">
          <white-item
            :availableAttachments="availableItems"
            v-model="value.form.key"
          ></white-item>
        </el-form-item>
        <el-form-item v-if="value.form.type == 1" label="检测项：">
          <el-select
            filterable
            v-model="value.form.key"
            placeholder="请选择条件"
          >
            <el-option
              v-for="item in availableDataMonitors"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="value.form.remark"
            type="textarea"
            rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="到期时间">
          <el-date-picker
            v-model="value.form.deadline"
            type="datetime"
            :clearable="false"
            placeholder="选择日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()" style="margin-left: 30px"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "EditWhiteListDialog";

import WhiteItem from "../components/WhiteItem.vue";

export default {
  data() {
    return {
      value: { isCreate: true, byType: "uid", form: { type: 0, key: "" } },
      availableItems: [
        {
          label: "全部",
          value: "",
          children: null,
        },
      ], // 预先填充一个全部的选项
      availableDataMonitors: [], // 可用的数据校验项
      rules: {},
    };
  },
  components: {
    WhiteItem,
  },

  async created() {
    let value = dialogutil.getData(DialogName);

    if (!value.isCreate) {
      this.value = value;
    }

    await this.loadAvailableItems();
    await this.loadAvailableDataMonitors();
  },

  methods: {
    async changeRadio(e) {
      this.value.form.key = "";
    },
    /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    /**
     * 修改
     */
    async update() {
      try {
        // 弹确认框
        await this.$confirm(`确认修改白名单？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updatePlayerDataAuditEntry`,
            {
              id: this.value.form.id,
              type: this.value.form.type,
              key: this.value.form.key,
              remark: this.value.form.remark,
              deadline: this.value.form.deadline,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) {}
    },

    /**
     * 新增
     */
    async create() {
      try {
        // 弹确认框
        await this.$confirm(`确认新增白名单项？`);

        if (this.value.byType == "uid") {
          this.value.form.aid = null;
        }
        if (this.value.byType == "aid") {
          this.value.form.uid = null;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addOnePlayerDataAuditEntry`,
            this.value.form,
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) {}
    },

    /**
     * 查询可用道具集合
     */
    async loadAvailableItems() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAppendixList`,
          {
            isShowPayItem: true,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      if (resData.data.categories.length > 0) {
        for (let category of resData.data.categories) {
          this.availableItems.push({
            label: category.name,
            value: category.name,
            children: (() => {
              let result = [];
              for (let e of category.entries) {
                result.push({
                  label: e.name,
                  value: String(e.id),
                });
              }
              return result;
            })(),
          });
        }
      }
    },

    /**
     *
     */
    async loadAvailableDataMonitors() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryDataMonitor`,
          {
            isShowPayItem: true,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }
      let listInResponse = resData.data.list || [];

      this.availableDataMonitors = listInResponse;
    },

    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>